/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Využijte slevu 10 % při přihlášení k odběru našeho zpravodaje.`
};

const da_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Få 10 % rabat ved at tilmelde dig vores nyhedsbrev`
};

const de_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Profitieren Sie von 10% Rabatt, wenn Sie sich für unseren Newsletter anmelden`
};

const en_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Enjoy a 10% discount when you sign up for our newsletter.`
};

const es_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Disfruta de un 10% al suscribirte a nuestro boletín`
};

const fr_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Profitez de -10% en vous inscrivant à notre newsletter`
};

const hu_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Iratkozzon fel hírlevelünkre és kapjon 10% kedvezményt`
};

const it_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Approfitta di uno sconto del 10% iscrivendoti alla nostra newsletter`
};

const nl_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Profiteer van 10% korting door je aan te melden voor onze nieuwsbrief`
};

const pl_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Skorzystaj z 10% zniżki, zapisując się do naszego newslettera`
};

const pt_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Aproveite 10% de desconto ao inscrever-se na nossa newsletter`
};

const sv_newsletter_footer_subscribe_description = /** @type {(inputs: {}) => string} */ () => {
	return `Få 10 % rabatt när du prenumererar på vårt nyhetsbrev`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_footer_subscribe_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_footer_subscribe_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_footer_subscribe_description", locale)
	if (locale === "cs") return cs_newsletter_footer_subscribe_description(inputs)
	if (locale === "da") return da_newsletter_footer_subscribe_description(inputs)
	if (locale === "de") return de_newsletter_footer_subscribe_description(inputs)
	if (locale === "en") return en_newsletter_footer_subscribe_description(inputs)
	if (locale === "es") return es_newsletter_footer_subscribe_description(inputs)
	if (locale === "fr") return fr_newsletter_footer_subscribe_description(inputs)
	if (locale === "hu") return hu_newsletter_footer_subscribe_description(inputs)
	if (locale === "it") return it_newsletter_footer_subscribe_description(inputs)
	if (locale === "nl") return nl_newsletter_footer_subscribe_description(inputs)
	if (locale === "pl") return pl_newsletter_footer_subscribe_description(inputs)
	if (locale === "pt") return pt_newsletter_footer_subscribe_description(inputs)
	return sv_newsletter_footer_subscribe_description(inputs)
};
export { newsletter_footer_subscribe_description as "newsletter.footer.subscribe_description" }